// extracted by mini-css-extract-plugin
export var leftAlign = "_y-2";
export var popper = "_y-0";
export var subtitle = "_y-1";